// MUI Components
import {
  Box,
  Typography
} from '@mui/material';

// lucide Icons
import {
  Trophy,
  SkipForward
} from 'lucide-react';

// Contexts
import { useTheme } from '../../contexts/ThemeContext';

export default function GameCompletionHeader({ score }) {
  const { theme } = useTheme();

  if (score > 0) {
    return (
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        mb: 2
      }}>
        <Trophy size={48} style={{ color: theme.accent.success, margin: '0 0 16px' }} />
        <Typography variant="h4" color={theme.accent.success} fontWeight={700} align="center" sx={{ fontSize: '1.75rem', fontFamily: theme.fontFamily }}>
          Game Completed!
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      mb: 2
    }}>
      <SkipForward size={48} style={{ color: theme.accent.error, margin: '0 0 16px' }} />
      <Typography variant="h4" color={theme.accent.error} fontWeight={700} align="center" sx={{ fontSize: '1.75rem', fontFamily: theme.fontFamily }}>
        Game Completed.
      </Typography>
    </Box>
  );
}
